import classNames from 'classnames';
import useDetectionCountdown from '../../../hooks/useDetectionCountdown.hook';

type Props = {
  targetDate: string;
  className?: string;
};

const DetectionCountdown = ({ targetDate, className }: Props) => {
  const remainingSeconds = useDetectionCountdown(targetDate);
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const isExpired = remainingSeconds === 0;

  return (
    <div
      className={classNames(
        'flex items-baseline gap-2 whitespace-nowrap text-lg',
        isExpired && 'text-red-500',
        className
      )}
    >
      <span className="font-medium">Time left to insert:</span>
      <time role="timer" dateTime={targetDate} className="text-2xl leading-none font-semibold tabular-nums">
        {minutes}:{seconds.toString().padStart(2, '0')}
      </time>
    </div>
  );
};

export default DetectionCountdown;
